import { FC } from 'react';
import { useTranslation } from 'hooks/api/useTranslation';
import { useCurrentSpend } from 'hooks/api/useCurrentSpend';
import { formatMonthlyPrice } from 'shared/helpers/formatMonthlyPrice';
import cls from './current-spend-banner.module.scss';

export const CurrentSpendBanner: FC = () => {
  const { t } = useTranslation();
  const { byProduct, billedTotal, currency } = useCurrentSpend();

  if (byProduct.length === 0) {
    return null;
  }

  const breakdown = byProduct
    .map(product => `${product.name} × ${product.count}`)
    .join(' · ');

  return (
    <div className={cls.currentSpendBanner}>
      <span className={cls.label}>{t('yourCurrentSpend')}</span>
      <span className={cls.figure}>
        <span className={cls.breakdown}>{breakdown}</span>
        <span className={cls.sep}>·</span>
        <span className={cls.total}>
          {formatMonthlyPrice(billedTotal, currency, t('month'))}
        </span>
      </span>
    </div>
  );
};
